import React from 'react'

function CheckedIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="20" rx="10" fill="url(#paint0_radial_3817_68383)" />
      <path d="M13.5913 7.33984L8.68188 12.2492L6.5 10.0673" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <radialGradient id="paint0_radial_3817_68383" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(25.02 25.24) rotate(-134.873) scale(41.4295 140.934)">
          <stop stopColor="#E60000" />
          <stop offset="1" stopColor="#9C2AA0" />
        </radialGradient>
      </defs>
    </svg>

  )
}

export default CheckedIcon